import { forumCommentsGetApi, forumCommentsPostApi, forumCRUDApi, forumGetApi } from "../constants/apis";
import axios from "axios";
import { getUserToken } from "../helpers/local_storage_helpers";

export const getForum = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(forumGetApi + "?page_sie=20" + `${query || ""}`, config);

    return response;
};

export const getForumChats = async (id) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(forumCommentsGetApi + id, config);
    return response;
};

export const sendForumMessage = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.post(forumCommentsPostApi, data, config);

    return response;
};

export const deleteForumMessage = async (id) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.delete(forumCommentsPostApi + id + "/", config);

    return response;
};

export const deleteForumApiCall = async (id) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.delete(forumCRUDApi + id + "/", config);

    return response;
};
